import { render, staticRenderFns } from "./HistoricalRecord.vue?vue&type=template&id=ccb26bde&scoped=true&"
import script from "./HistoricalRecord.vue?vue&type=script&lang=js&"
export * from "./HistoricalRecord.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalRecord.vue?vue&type=style&index=0&id=ccb26bde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb26bde",
  null
  
)

export default component.exports